<div class="operations-form">
  @if (operations.length === 0) {
    <div class="operations-empty">{{ 'PROCESSINGS.OPERATIONS.EMPTY' | translate }}</div>
  }

  <div class="operations-list">
    @for (operation of operations; track operation.id; let i = $index) {
      <div class="op-wrapper" [class.is-barrier]="isBarrier(operation)">
        <div class="op-group">
          <div class="op-header-row">
            <div class="op-header-left">
              <span class="op-title">{{ 'PROCESSINGS.OPERATIONS.TITLE' | translate }} {{ i + 1 }}</span>
              <button type="button" class="op-scope-toggle"
                [class.is-document]="isBarrier(operation)"
                (click)="setScope(i, isBarrier(operation) ? 'field' : 'document')"
                [title]="(isBarrier(operation)
                  ? 'PROCESSINGS.OPERATIONS.SCOPE_DOCUMENT_HINT'
                  : 'PROCESSINGS.OPERATIONS.SCOPE_FIELD_HINT') | translate">
                <fa-icon [icon]="isBarrier(operation) ? icons.faLayerGroup : icons.faFileLines"></fa-icon>
                <span>{{ (isBarrier(operation)
                  ? 'PROCESSINGS.OPERATIONS.SCOPE_DOCUMENT'
                  : 'PROCESSINGS.OPERATIONS.SCOPE_FIELD') | translate }}</span>
              </button>
              @if (!isBarrier(operation) && !readsOriginalDocument(i)) {
                <span class="op-reads-from"
                  [title]="'PROCESSINGS.OPERATIONS.READS_FROM_HINT' | translate">
                  {{ 'PROCESSINGS.OPERATIONS.READS_FROM' | translate:{ target: barrierLabel(i) } }}
                </span>
              }
            </div>
            <div class="op-header-actions">
              <fa-icon class="op-action-icon delete-icon" [icon]="icons.faTrash"
                (click)="removeOperation(i)" [title]="'BUTTON.DELETE' | translate"></fa-icon>
            </div>
          </div>

          <div class="op-name-row">
            <input
              type="text"
              class="op-description"
              [(ngModel)]="operation.description"
              (ngModelChange)="emitChange()"
              [placeholder]="'PROCESSINGS.OPERATIONS.DESCRIPTION_PLACEHOLDER' | translate" />
            @if (!isBarrier(operation)) {
              <input
                type="text"
                class="op-target"
                [(ngModel)]="operation.target"
                (ngModelChange)="emitChange()"
                [title]="'PROCESSINGS.OPERATIONS.TARGET_HINT' | translate"
                [placeholder]="defaultTarget(i)" />
            }
          </div>

          @if (isNative(operation)) {
            <div class="op-native">
              <ol class="op-native-passes"
                [title]="'PROCESSINGS.OPERATIONS.NATIVE_HINT' | translate">
                @for (line of passSummary(operation); track $index) {
                  <li>{{ line }}</li>
                }
              </ol>
              <button type="button" class="op-native-toggle" (click)="toggleParams(operation)">
                {{ (editingParams(operation)
                    ? 'PROCESSINGS.OPERATIONS.PARAMS_HIDE'
                    : 'PROCESSINGS.OPERATIONS.PARAMS_EDIT') | translate }}
              </button>
              @if (editingParams(operation)) {
                <app-jsonata-field
                  [value]="paramsJson(operation)"
                  [rows]="6"
                  (valueChange)="onParamsJson(operation, $event)"></app-jsonata-field>
                @if (operation.paramsError) {
                  <div class="op-native-error">{{ 'PROCESSINGS.OPERATIONS.PARAMS_INVALID' | translate }}</div>
                }
              }
            </div>
          }

          @if (!isNative(operation)) {
          <div class="op-type-switch">
            <button type="button" [class.active]="operation.type === 'jsonata'" (click)="setType(i, 'jsonata')">
              <fa-icon [icon]="icons.faCode"></fa-icon>
              <span>{{ 'PROCESSINGS.OPERATIONS.TYPE_JSONATA' | translate }}</span>
            </button>
            <button type="button" [class.active]="operation.type === 'ai'" (click)="setType(i, 'ai')">
              <fa-icon [icon]="icons.faWandMagicSparkles"></fa-icon>
              <span>{{ 'PROCESSINGS.OPERATIONS.TYPE_AI' | translate }}</span>
            </button>
          </div>

          @if (operation.type === 'jsonata') {
            <app-jsonata-field
              [value]="operation.expression || ''"
              [rows]="3"
              [placeholder]="'PROCESSINGS.OPERATIONS.EXPRESSION_PLACEHOLDER' | translate"
              (valueChange)="operation.expression = $event; emitChange()"></app-jsonata-field>
          } @else {
            <textarea
              class="op-field"
              rows="3"
              [(ngModel)]="operation.instruction"
              (ngModelChange)="emitChange()"
              [placeholder]="'PROCESSINGS.OPERATIONS.INSTRUCTION_PLACEHOLDER' | translate"></textarea>
          }
          }

          @if (isBarrier(operation)) {
            <div class="op-barrier-note">
              {{ 'PROCESSINGS.OPERATIONS.BARRIER_NOTE' | translate }}
            </div>
          }

          <div class="op-actions">
            @if (allowTest && canTest(operation)) {
              <button type="button" class="op-test" (click)="test(i)">
                <fa-icon [icon]="icons.faBolt"></fa-icon>
                <span>{{ 'PROCESSINGS.OPERATIONS.TEST' | translate }}</span>
              </button>
            }
          </div>
        </div>
      </div>
    }
  </div>

  <div class="operations-add">
    <button type="button" class="add-description" (click)="addOperation('jsonata')">
      <fa-icon class="icon" [icon]="icons.faPlus"></fa-icon>
      <span>{{ 'PROCESSINGS.OPERATIONS.ADD' | translate }}</span>
    </button>
  </div>
</div>
